// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ks-0";